if (!customElements.get('listrak-waitlist-form')) {
  customElements.define(
    'listrak-waitlist-form',
    class ListrakWaitlistForm extends HTMLElement {
      constructor() {
        super();
        this._ltkInitialized = false;
        this._boundOnSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        this.error = this.querySelector('[data-error]');
        this.errorText = this.error?.textContent;

        this.errorCheckbox = this.querySelector('[data-error-checkbox]');
        this.errorCheckboxText = this.errorCheckbox?.textContent;

        this.success = this.querySelector('[data-success]');
        this.successText = this.success?.textContent;

        this.form?.addEventListener('submit', this._boundOnSubmit);

        // Call setupListrak() at connect time so _ltk.Signup.New() has time to
        // register its async click handler before the user submits. If _ltk isn't
        // loaded yet, retry once it arrives.
        if (!this.setupListrak()) {
          this._ltkRetryInterval = setInterval(() => {
            if (this.setupListrak()) clearInterval(this._ltkRetryInterval);
          }, 300);
        }
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this._boundOnSubmit);
        clearInterval(this._ltkRetryInterval);
      }

      setupListrak() {
        if (this._ltkInitialized) return true;
        if (!window._ltk?.Signup) return false;

        const listId = this.dataset.listId;
        _ltk.Signup.New(listId, 'waitlist-email', _ltk.Signup.TYPE.CLICK, 'waitlist-listrak-trigger', 'email');
        _ltk.Signup.SetField(listId, 'waitlist-phone');
        _ltk.Signup.SetOptIn(listId, 'waitlist-sms-optin');
        this._ltkInitialized = true;
        return true;
      }

      onSubmit(event) {
        event.preventDefault();
        this.removeAttribute('error');
        this.removeAttribute('error-checkbox');

        const formData = new FormData(this.form);
        const email = (formData.get('Email') || '').trim();
        const phoneNumber = (formData.get('PhoneNumber') || '').trim();

        const smsOptInCheckbox = this.form.querySelector('[name="SmsOptIn"]');
        const smsOptedIn = smsOptInCheckbox?.checked || false;

        if (!smsOptedIn) {
          this.setAttribute('error-checkbox', '');
          return;
        }

        if (!email) {
          this.setAttribute('error', '');
          return;
        }

        if (!this._ltkInitialized) {
          console.error('listrak-waitlist-form: _ltk.Signup is not available.');
          return;
        }

        const trigger = this.querySelector('#waitlist-listrak-trigger');
        if (trigger) {
          trigger.click();
          this.setAttribute('success', '');
          this.form.reset();
          setTimeout(() => {
            this.removeAttribute('success');
          }, 3000);
        }
      }

      static get observedAttributes() {
        return ['error', 'error-checkbox', 'success'];
      }

      attributeChangedCallback(name) {
        if (name === 'error') {
          this.refreshErrorText();
        } else if (name === 'error-checkbox') {
          this.refreshErrorCheckboxText();
        } else if (name === 'success') {
          this.refreshSuccessText();
        }
      }

      refreshErrorText() {
        if (!this.error || this.error.textContent === '') return;
        this.error.textContent = '';
        this.error.textContent = this.errorText;
      }

      refreshErrorCheckboxText() {
        if (!this.errorCheckbox || this.errorCheckbox.textContent === '') return;
        this.errorCheckbox.textContent = '';
        this.errorCheckbox.textContent = this.errorCheckboxText;
      }

      refreshSuccessText() {
        if (!this.success || this.success.textContent === '') return;
        this.success.textContent = '';
        this.success.textContent = this.successText;
      }

      get form() {
        return this.querySelector('form') || '';
      }
    }
  );
}
